export const truncateWithLength = (data = '', length = 20) => {
  if (!data) return '-';
  let temp = data?.substring(0, length - 2);
  if (data.length >= length - 2) {
    temp += '...';
  }
  return temp;
};

export const sortedResultWithScore = (results) => {
  return Object.entries(results)
    .map(([type, items]) => {
      const sortedItems = [...items].sort((a, b) => b.score - a.score);
      const maxScore = sortedItems.length ? sortedItems[0].score : 0;
      return { type, maxScore, items: sortedItems };
    })
    .sort((a, b) => b.maxScore - a.maxScore);
};
